import * as React from "react";
import { FC } from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { TitleMelCategory } from "./Constant/Source";
import MelCategoryCreateForm from "./Forms/MelCategoryCreateForm";

const MelCategoryCreate: FC<CreateProps> = props => {
  return (
    <Create {...props} title={TitleMelCategory.create}>
      <SimpleForm>
        <MelCategoryCreateForm />
      </SimpleForm>
    </Create>
  );
};

export default MelCategoryCreate;
